import { HttpMethod } from '@teqplay/api'

import { requestBuilder } from '../builder'

export type TShipSearchItem = { imo: string; name: string }

export type TGetShipSearchInput = { pattern: string }
export type TGetShipSearchOutput = TShipSearchItem[]

const search = requestBuilder
  .type<TGetShipSearchInput, TGetShipSearchOutput>()
  .request(({ input: { pattern } }) => ({
    path: `/v1/ship/search/${encodeURIComponent(pattern)}`,
    method: HttpMethod.GET
  }))

export type TGetAllImosInput = void
export type TGetAllImosOutput = string[]

const getAllImos = requestBuilder.type<TGetAllImosInput, TGetAllImosOutput>().request(() => ({
  path: `/v1/ship/allImos`,
  method: HttpMethod.GET
}))

const ship = { search, getAllImos }
export default ship
